// attacks_against_cannot_gain_adv (2026-10-02, Psion Mind of the Clairvoyant L25 "Foreseen Assault": "Attacks against you cannot
// gain advantage"). Carried by the attack's TARGET — authored on a passive, promoted to the creature ROOT as `[1]` by
// finalize_creature_arr's feat / passive fold (twins: c1_live.php FT_C1_FOLD_ROOT_FLAGS, possessor-compile.ts FOLD_ROOT_FLAGS).
//
// A NET clamp, applied last before the d20: the attack ends straight or at disadvantage, never above the attacker's own
// positive Manual sidebar stacks (a deliberate table ruling — the same carve-out as ignore_all_attack_roll_dis). Disadvantage
// sources are untouched. Lanes: skillRollArr (spell attacks + the template weapon attack) and the natural-weapon lane's
// resolveAdvDisStacks. The legacy PHP copy is ft_adv_dis_clamp_advantage_against() — retirement row R-135.

import { type Row, record } from '../context.js';

export const ATTACKS_AGAINST_CANNOT_GAIN_ADV = 'attacks_against_cannot_gain_adv';
export const ATTACKS_AGAINST_CANNOT_GAIN_ADV_LABEL = 'Attacks against it cannot gain advantage';

/** Weapon Melee / Weapon Ranged / Spell Melee / Spell Ranged Attack Roll. */
export const ATTACK_ROLL_TYPE_IDS: ReadonlySet<string> = new Set([
  '2FE8DFB7-FE61-4862-AF71-3523262350A0',
  '3F85CA97-F9B2-A83A-FDE8-E523FD99346C',
  '5740CA49-006E-A7A0-B46B-6DDED6CD546C',
  'DD280A3B-6F1D-4CE9-9EFD-505A74D0C07C',
]);

/** PHP `!empty()` over a flag value: `[1]`, `1`, `'1'` → true; absent / `0` / `'0'` / `''` / `[]` → false. */
export function flagSet(raw: unknown): boolean {
  if (Array.isArray(raw)) return raw.some(flagSet);
  return raw !== undefined && raw !== null && raw !== '' && raw !== 0 && raw !== '0' && raw !== false;
}

/** The promoted ROOT slot (finalize_creature_arr writes `$item_arr[layer] = [1]`). */
export function rootFlagSet(row: Row | null, layer: string): boolean {
  return flagSet(record(row)?.[layer]);
}

/** The roll's stacks after the clamp: never above max(0, manualAdv). */
export function clampAttackAdvAgainst(stacks: number, manualAdv = 0): number {
  return Math.min(stacks, Math.max(0, manualAdv));
}
